import { useState } from "react";
import { documentService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { IDocumentPayloadParams } from "@miplatform/types";

export const useDocuments = () => {
  const [refresh, setRefresh] = useState(false);

  const stateManager = useComponentState();

  const createDocument = ({
    data,
    params,
    contentType,
  }: ICreateDocumentParams) => {
    return stateManager.run(() => {
      return documentService.documents.create({
        data,
        params,
        contentType,
      });
    });
  };

  const deleteDocument = ({ id, modifiedOn = "" }: IDeleteDocumentParams) => {
    return stateManager.run(async () => {
      const response = await documentService.documents.delete({
        id,
        modifiedOn,
      });
      if (response.status === HTTP_STATUSES.OK) {
        setRefresh((prev) => !prev);
      }
      return response;
    });
  };

  return {
    isLoading: stateManager.isBusy(),
    refresh,
    createDocument,
    deleteDocument,
  };
};

interface ICreateDocumentParams {
  data: File;
  params: IDocumentPayloadParams;
  contentType?: string;
}

interface IDeleteDocumentParams {
  id: string;
  modifiedOn?: string;
}
